export default "__VITE_ASSET__e49a5cf7__"